import React from 'react';
import { Table } from 'antd';
import dayjs from 'dayjs';
import { stringToMoneyFormat } from 'utils';

const SalesTable = (props) => {
  /* ===== Route ===== */
  /* ===== Props ===== */
  const { data = [] } = props;

  /* ===== State ===== */
  /* ===== Hooks ===== */
  /* ===== Function ===== */
  /* ===== Variable ===== */
  const columns = [
    {
      key: 'date',
      dataIndex: 'date',
      title: '날짜',
      fixed: 'left',
    },
    {
      key: 'total_sales',
      dataIndex: 'total_sales',
      title: '총매출',
      render: (item) => stringToMoneyFormat(item),
    },
    {
      key: 'COMPLETED_sales',
      dataIndex: 'COMPLETED_sales',
      title: '순매출',
      render: (item) => stringToMoneyFormat(item),
    },
    {
      key: 'CANCELLED_sales',
      dataIndex: 'CANCELLED_sales',
      title: '환불금액',
      render: (item) => stringToMoneyFormat(item),
    },
    {
      key: 'COMPLETED_count',
      dataIndex: 'COMPLETED_count',
      title: '거래건수',
      render: (item) => stringToMoneyFormat(item),
    },
    {
      key: 'CANCELLED_count',
      dataIndex: 'CANCELLED_count',
      title: '환불건수',
      render: (item) => stringToMoneyFormat(item),
    },
  ];

  /* ===== Hooks ===== */
  /**
   * 일자별 테이블 데이터 정제
   * --
   */
  const tableData = React.useMemo(() => {
    if (!data.length) return [];

    const dateData = data.reduce((acc, cur) => {
      const { created_at, payment_price, payment_state, received_present } =
        cur;

      const date = dayjs.unix(created_at).format('YYYY-MM-DD');

      if (acc[date]) {
        acc[date] = {
          ...acc[date],
          total_sales: acc[date]['total_sales'] + payment_price,
          [`${payment_state}_sales`]:
            acc[date][`${payment_state}_sales`] + payment_price,
          [`${payment_state}_count`]:
            acc[date][`${payment_state}_count`] + received_present,
        };
      } else {
        const initial = {
          total_sales: 0,
          COMPLETED_sales: 0,
          CANCELLED_sales: 0,
          COMPLETED_count: 0,
          CANCELLED_count: 0,
        };
        acc[date] = {
          ...initial,
          total_sales: payment_price,
          [`${payment_state}_sales`]: payment_price,
          [`${payment_state}_count`]: received_present,
        };
      }

      return acc;
    }, {});

    const mappingData = Object.entries(dateData)
      .map(([key, value]) => ({
        date: key,
        ...value,
      }))
      .sort((a, b) => dayjs(b.key) - dayjs(a.key));

    return mappingData;
  }, [data]);

  /* ===== Render ===== */
  return (
    <Table
      bordered
      size="small"
      scroll={{ x: 760, y: 290 }}
      pagination={false}
      columns={columns}
      dataSource={tableData}
      summary={(pageData) => {
        const summary = pageData.reduce(
          (acc, cur) => {
            Object.entries(cur).forEach(([key, value]) => {
              if (key === 'date') return;
              acc[key] += value;
            });

            return acc;
          },
          {
            total_sales: 0,
            COMPLETED_sales: 0,
            CANCELLED_sales: 0,
            COMPLETED_count: 0,
            CANCELLED_count: 0,
          }
        );

        return (
          <Table.Summary fixed>
            <Table.Summary.Row>
              <Table.Summary.Cell index={0}>
                <b>합계</b>
              </Table.Summary.Cell>

              {Object.values(summary).map((item, index) => (
                <Table.Summary.Cell key={`summary-${index}`} index={index + 1}>
                  <b>{stringToMoneyFormat(item)}</b>
                </Table.Summary.Cell>
              ))}
            </Table.Summary.Row>
          </Table.Summary>
        );
      }}
    />
  );
};

export default SalesTable;
